var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 0.336945H1.33341C1.1566 0.336945 0.987034 0.407182 0.86201 0.532207C0.736986 0.657231 0.666748 0.8268 0.666748 1.00361V11.6703C0.666748 11.8471 0.736986 12.0167 0.86201 12.1417C0.987034 12.2667 1.1566 12.3369 1.33341 12.3369H14.6667C14.8436 12.3369 15.0131 12.2667 15.1382 12.1417C15.2632 12.0167 15.3334 11.8471 15.3334 11.6703V1.00361C15.3334 0.8268 15.2632 0.657231 15.1382 0.532207C15.0131 0.407182 14.8436 0.336945 14.6667 0.336945V0.336945ZM14.0001 11.0036H2.00008V4.65494L7.75208 6.95628C7.91139 7.01939 8.08877 7.01939 8.24808 6.95628L14.0001 4.65494V11.0036ZM14.0001 3.21894L8.00008 5.61894L2.00008 3.21894V1.67028H14.0001V3.21894Z",
    fill: "#4A4D55"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/email.6f2ebd41eb94a4555a4a5eac532c0e6b.svg";